export const NOTE_TYPES = {
  INTERNAL_NOTE: 'Intern anteckning',
  HEALTH_EXAMINATION: 'Journalanteckning fysisk hälsoundersökning',
  FOLLOW_UP: 'Journalanteckning efter uppföljning',
  CONSULTATION: 'Journalanteckning efter samtal',
  NO_MEETING: 'Journalanteckning utan möte',
  HEALTH_PROGRAMS: 'Journalanteckning vid hälsoprogram',
};

export const TEST_ID = {
  BMI: 13,
  SGPALS: 19,
  STRESS_KEDS: 22,
  SMOKING: 52,
  ECG: 80,
  PULSE: 81,
  STRESS_PSS: 82,
  SOCPHY: 88,
  ANSWERED_DIABETES: 51,
  ANSWERED_WANT_FOLLOW_UP: 56,
  SATURATION: 90, // Syremättnad (Blood Oxygen Saturation)
  HEART_RHYTHM: 91, // Hjärtrytm
  ANSWERED_PREGNANCY: 92,
  WOMENS_HEALTH: 86,
  WOMENS_HEALTH_2025: 93,
  SPIROMETRY: 95,
  HEARING: 96,
};
